import React from "react";
import { TooltipHost, Stack, Icon } from "sprint-common-web";

interface RenderTrailerVersionInfoProps {
    isItemInactive?: boolean;
}

export const renderTrailerVersionInfo = ({ isItemInactive }: RenderTrailerVersionInfoProps): JSX.Element => {
    return (
        <TooltipHost content="Trailer version" hidden={isItemInactive}>
            <Stack
                verticalAlign="center"
                horizontalAlign="center"
                styles={{
                    root: {
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        backgroundColor: "#0078d4",
                        opacity: isItemInactive ? 0.7 : 1
                    }
                }}
            >
                <Icon disabled={isItemInactive} iconName="Info" color="#ffffff" size={21} />
            </Stack>
        </TooltipHost>
    );
};
